'use client'

import { clearRootApiClientAccessToken } from '@/lib/apis/clients/ApiClientStore'
import DesktopPortalLinks, {
  type DesktopPortalLinksProps,
} from '@/shared/components/navigation/DesktopPortalLinks'

export default function DesktopPortalLinksContainer(
  props: DesktopPortalLinksProps,
) {
  return (
    <DesktopPortalLinks
      {...props}
      onLogout={async () => {
        clearRootApiClientAccessToken()
        try {
          await props.onLogout()
        } finally {
          clearRootApiClientAccessToken()
        }
      }}
    />
  )
}
